import ManualAddress from './ManualAddress';
export { ManualAddress as default };
